import { fbSlice } from './slice';

export const {
  setPixelToDelete
} = fbSlice.actions;
